export class SetMenuVisibility {
    static readonly type = "[APP] Set menu visibility";

    constructor(public payload: boolean) {}
}
